import {
    ANNULEE_STATE_KEY,
    AUDIT_METADATA_AVATAR_TYPE_NAME,
    AUDIT_STATE_AUDIT_HUMAN_ID,
    AVATAR_PROPERTIES,
    AVATAR_TRACEABILITY_NOTES,
    AVATARS,
    CHANGE_DEMANDS_TO,
    DISORDER_CHANGE_STATUS_NODE_LIST,
    EN_ATTENTE_REALISATION_STATE_KEY,
    GROUP_AVATARS,
    INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT,
    INTERVENTION_CREATED_FROM_AVATAR_PROPERTY,
    INTERVENTION_TYPE_NAME_AUDIT_OUT_OF_CONTRACT,
    INTERVENTION_TYPE_NAME_VALUES,
    PLANNED_DATE_AVATAR_PROPERTY,
    REALISEE_STATE_KEY,
    TO_EVALUATE_STATE_KEY,
    TRACEABILITY_TRACKING_V2_CHANGE_NODE_1,
} from '@/utils/CONST';
import ChangeStatusField from '@/components/common/change-status-field/change-status-field';
import { useCreate, useDelete, useListContext, useNotify } from 'react-admin';
import { getAvatarPropertyId, getAvatarPropertyValue } from '@/utils/getProperty';
import { useQueryClient } from '@tanstack/react-query';
import useGetAvatarProperties from '@/hooks/useGetAvatarProperties';
import { nth } from 'lodash';
import { useUpdate } from 'react-admin';
import useGetAvatars from '@/hooks/useGetAvatars';
import { useParams } from 'react-router';

interface Props {
    currentNode: any;
    groupAvatars: string[];
    id: string;
}

const ChangeInterventionStatusField = ({ id, currentNode, groupAvatars }: Props) => {
    const [create] = useCreate();
    const [deleteOne] = useDelete();
    const [update] = useUpdate();
    const { placeId } = useParams();

    const notify = useNotify();

    const { refetch } = useListContext();
    const { properties } = useGetAvatarProperties({
        avatarId: id,
    });
    const createdFrom = getAvatarPropertyValue(properties, INTERVENTION_CREATED_FROM_AVATAR_PROPERTY);
    const queryClient = useQueryClient();

    const { avatars: audits } = useGetAvatars({
        filters: {
            'groupAvatars.id': nth(groupAvatars, 1) ?? '',
            metadataAvatarTypeEName: [AUDIT_METADATA_AVATAR_TYPE_NAME],
            enabled: true,
            // 'groupAvatars.id': groupAvatar,
            parent: placeId,
        },
        enabled: createdFrom === INTERVENTION_TYPE_NAME_AUDIT_OUT_OF_CONTRACT,
    });

    // console.log(avatars);

    const planned_date = getAvatarPropertyId(properties, PLANNED_DATE_AVATAR_PROPERTY);

    const handleChangeFromDevisIntervention = (idForNodeHumanReadable: string) => {
        if (
            idForNodeHumanReadable === INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT[EN_ATTENTE_REALISATION_STATE_KEY].id
        ) {
            return deleteOne(
                AVATAR_PROPERTIES,
                {
                    id: planned_date,
                },
                {
                    onSuccess: () => {
                        queryClient.refetchQueries({ queryKey: [AVATAR_TRACEABILITY_NOTES] });
                        refetch();
                        notify('disorder.actions.change_status.one', { type: 'success' });
                    },
                },
            );
        } else if (idForNodeHumanReadable === INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT[ANNULEE_STATE_KEY].id) {
            handleChangeInterventionsToAnulee(
                id,
                nth(groupAvatars, 1) ?? '',
                DISORDER_CHANGE_STATUS_NODE_LIST[TO_EVALUATE_STATE_KEY].id,
            );
        }
    };

    const handleChangeInterventionsToAnulee = (id: string, groupAvatar: string, idForNodeHumanReadable: string) => {
        create(
            CHANGE_DEMANDS_TO,
            {
                data: {
                    groupAvatar,
                    traceabilityHumanId: idForNodeHumanReadable,
                    intervention: id,
                    addInterventionToGroupAvatar: false,
                },
            },
            {
                onSuccess: () => {
                    update(
                        AVATARS,
                        { id, data: { groupAvatars: [] } },
                        {
                            onSuccess: () => {
                                queryClient.invalidateQueries({ queryKey: [AVATARS, 'getList'] });
                                notify('disorder.actions.change_status.one', { type: 'success' });
                            },
                        },
                    );
                },
            },
        );
    };

    const handleChangeAuditIntervention = (idForNodeHumanReadable: string) => {
        if (
            idForNodeHumanReadable === INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT[EN_ATTENTE_REALISATION_STATE_KEY].id
        ) {
            return deleteOne(
                AVATAR_PROPERTIES,
                {
                    id: planned_date,
                },
                {
                    onSuccess: () => {
                        queryClient.refetchQueries({ queryKey: [AVATAR_TRACEABILITY_NOTES] });
                        refetch();
                        notify('disorder.actions.change_status.one', { type: 'success' });
                    },
                },
            );
        } else if (idForNodeHumanReadable === INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT[ANNULEE_STATE_KEY].id) {
            // handleChangeInterventionsToAnulee(id, nth(groupAvatars, 1) ?? '', AUDIT_STATE_AUDIT_HUMAN_ID);
            create(
                TRACEABILITY_TRACKING_V2_CHANGE_NODE_1,
                {
                    data: {
                        avatar: nth(audits)?.id ?? '',
                        idForNodeHumanReadable: AUDIT_STATE_AUDIT_HUMAN_ID,
                        version: 1,
                        extraData: [],
                    },
                },
                {
                    onSuccess: () => {
                        update(
                            AVATARS,
                            { id, data: { groupAvatars: [] } },
                            {
                                onSuccess: () => {
                                    queryClient.invalidateQueries({ queryKey: [AVATARS, 'getList'] });
                                    queryClient.invalidateQueries({ queryKey: [GROUP_AVATARS] });
                                    notify('disorder.actions.change_status.one', { type: 'success' });
                                },
                            },
                        );
                    },
                },
            );
        }
    };

    // const handleChange = (idForNodeHumanReadable: string) => {
    //     if (
    //         idForNodeHumanReadable === INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT[EN_ATTENTE_REALISATION_STATE_KEY].id
    //     ) {
    //         return deleteOne(
    //             AVATAR_PROPERTIES,
    //             {
    //                 id: planned_date,
    //             },
    //             {
    //                 onSuccess: () => {
    //                     queryClient.refetchQueries([AVATAR_TRACEABILITY_NOTES]);
    //                     // if (createdFrom === INTERVENTION_TYPE_NAME_VALUES[0]) {
    //                     //     handleChangeInterventionsToAnulee(id, groupAvatars, idForNodeHumanReadable);
    //                     // }
    //                     refetch();
    //                     notify('disorder.actions.change_status.one');
    //                 },
    //             },
    //         );
    //     } else if (
    //         createdFrom === INTERVENTION_TYPE_NAME_VALUES[0] &&
    //         idForNodeHumanReadable === INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT[ANNULEE_STATE_KEY].id
    //     ) {
    //         create(
    //             CHANGE_DEMANDS_TO,
    //             {
    //                 data: {
    //                     groupAvatar: nth(groupAvatars),
    //                     traceabilityHumanId: '0010',
    //                     intervention: id,
    //                 },
    //             },
    //             {
    //                 onSuccess: () => {
    //                     update(
    //                         AVATARS,
    //                         { id, data: { groupAvatars: [] } },
    //                         { onSuccess: () => notify('disorder.actions.change_status.one') },
    //                     );
    //                 },
    //             },
    //         );
    //     }
    // };

    return (
        <ChangeStatusField
            avatarUriId={id}
            currentNode={currentNode}
            choices={Object.values(INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT)}
            callback={
                createdFrom === INTERVENTION_TYPE_NAME_VALUES[0]
                    ? handleChangeFromDevisIntervention
                    : handleChangeAuditIntervention
            }
            disabled={
                INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT[REALISEE_STATE_KEY].id ===
                currentNode?.configuration?.idForNodeHumanReadable
            }
        />
    );
};

export default ChangeInterventionStatusField;
